module.exports = "<div class=\"y-box-filter\">\n  <div class=\"pull-left y-box-filter-title\">\n    <span data-bind=\"text:title\"></span>\n  </div>\n  <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/boxfilter/index.html
// module id = 218
// module chunks = 0